<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item>
                <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            </el-form-item>
            <!--<el-form-item label="所属组" v-show="groupData.length>0">-->
                <!--<el-select v-model="formInline.tagGroupId" clearable filterable placeholder="所属组" >-->
                    <!--<el-option v-for="item in groupData"-->
                               <!--:key="item.id"-->
                               <!--:label="item.groupName"-->
                               <!--:value="item.id">-->
                    <!--</el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
            <el-form-item>
                <spa>{{tagName}}</spa>
            </el-form-item>
        <el-form-item>
            <el-button-group style="margin: 5px 0">
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleAdd">新增</el-button>
                <!--<el-button type="primary" @click="pullTag">同步标签</el-button>-->
            </el-button-group>
        </el-form-item>
        </el-form>

        <div class="content-wrap">
            <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="groupName" label="分组名称"  width="120"></el-table-column>
                <el-table-column prop="tagName" label="标签名称" width="120"></el-table-column>
                <el-table-column prop="createTime"  label="创建时间" ></el-table-column>
                <el-table-column prop="conditionTypeName"  label="组内规则条件" ></el-table-column>
                <!--<el-table-column prop="userNum" label="客户数" width="150" ></el-table-column>-->
                <el-table-column label="操作" fixed="right" width="350">
                    <template slot-scope="scope">
                        <el-button-group style="margin: 5px 0">
                            <el-button type="danger"  size="mini" @click="handDelete(scope.row)">删除</el-button>
                            <el-button type="primary"  size="mini" @click="handleEdit(scope.row)">修改规则组关系</el-button>
                            <el-button type="danger"  size="mini" @click="handGetRule(scope.row)">查看组内规则</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="标签规则组逻辑关系" :visible.sync="dialogFormRuleGrouVisible" center>
            <el-form :model="tagData" label-width="120px">
                <el-form-item label="标签规则组间有关系" >
                    <el-select v-model="tagData.conditionType"  clearable filterable placeholder="规则组逻辑关系" >
                        <el-option v-for="itemD in conditionTypeData"
                                   :key="itemD.id"
                                   :label="itemD.name"
                                   :value="itemD.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button-group style="margin: 5px 0">
                        <el-button @click="dialogFormRuleGrouVisible = false"  size="mini">取 消</el-button>
                        <el-button type="primary" size="mini" @click="saveTagItemCondition">确 定</el-button>
                    </el-button-group>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="新增" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.id ></el-input>
                </el-form-item>

                <el-form-item label="选择标签" required="true" >
                    <el-select v-model="form.tagId" @change="onGroupChange" clearable filterable placeholder="所属组" >
                        <el-option v-for="item in groupData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="组名称" required="true">
                    <el-input type="text" v-model=form.groupName clearable  placeholder="组名称" maxlength="30"
                              show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="规则组逻辑关系" required="true">
                    <el-select v-model="form.conditionType"  clearable filterable placeholder="规则组逻辑关系" >
                        <el-option v-for="itemD in conditionTypeData"
                                   :key="itemD.id"
                                   :label="itemD.name"
                                   :value="itemD.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button-group style="margin: 5px 0">
                        <el-button @click="dialogFormVisible = false"  size="mini">取 消</el-button>
                        <el-button type="primary" size="mini" @click="save(form)">确 定</el-button>
                    </el-button-group>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getTagList,getTagRuleGroupList,deletRuleGroup,saveRuleGroup} from '../../api/api';
    //定义组件
    export default{
        data(){
            return {
                listData:[],
                groupData:[],
                showAddGroup:false,
                statusData:[{"id":0,"name":"否"},{"id":1,"name":"是"}],
                conditionTypeData:[{"id":1,"name":"且"},{"id":2,"name":"或"}],
                loading:true,
                tagName:''||this.$route.query.tagName,
                dialogFormVisible:false,
                dialogFormRuleGrouVisible:false,
                tagData:{},
                form:{"id": null,
                    "tagId": null||this.$route.query.tagId,
                    "corpId":0,
                    "groupName": "",
                    "conditionType":1,
                },
                formInline:{
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                    tagId:null||this.$route.query.tagId,
                },
            }
        },
        //挂载时候执行
        mounted(){
            this.getTagItemList();
            this.getList();
        },
        components:{

        },
        methods:{
            //定义查询方法
            getList(){
                this.loading=true
                getTagRuleGroupList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.value.total;
                    this.listData = res.data.value.list;
                })
            },
            editTagRuleGroup(row){

            },
            handGetRule(row){
                this.$router.push({
                    path: '/tagRule',
                    query: {
                        ruleGroupId: row.id,
                        groupName:row.groupName
                    }
                })
            },
            getTagItemList(){
                getTagList({currentPage:1,pageSize:3000}).then((res) => {
                    this.loading = false;
                    //this.formInline.recordsTotal = res.data.value.total;
                    this.groupData = res.data.value.list;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd(){
                this.dialogFormVisible=true;
                this.form={"id": null,
                    "tagId": "",
                    "groupName": "",
                    "corpId":0,
                    "conditionType":1,
                }
                this.form.tagId=this.formInline.tagId;
                this.form.groupName=this.tagName;
            },

            handleEdit(data){
                this.tagData=data
                this.dialogFormRuleGrouVisible=true
            },
            save(data){
                console.log(data);
//                if(data.group_id===""&&data.group_name===""){
//                    this.$message({
//                        message:"请选择分组或填写分组名称",
//                        type:'error'
//                    });
//                    return;
//                }
                //保存标签
                saveRuleGroup(data).then((res) => {
                    //console.log(res);
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });
            },
            saveTagItemCondition(){
                saveTag(this.tagData).then((res) => {
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormRuleGrouVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });
            },
            handDelete(row){
                this.$confirm('删除'+row.groupName+', 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    deletRuleGroup({id:row.id}).then((res) => {
                        this.loading = false;
                        if(res.data.success){
                            this.$message({
                                message:res.data.message,
                                type:'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        }else{
                            this.$message({
                                message:res.data.message,
                                type:'error'
                            });
                        }
                    })
                });
            },
            returnHistory(){
                window.history.back()
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/distribution/tagRuleGroup.vue